export const API_URL = (process.env as any)['REACT_APP_API_URL'];
export const HEAP_ID = (process.env as any)['REACT_APP_HEAP_ID'];
export const GTM_ID = (process.env as any)['REACT_APP_GTM_ID'];
